/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_StopInputs */

const en_admin_ai_chat_stop = /** @type {(inputs: Admin_Ai_Chat_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop`)
};

const de_admin_ai_chat_stop = /** @type {(inputs: Admin_Ai_Chat_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stoppen`)
};

const es_admin_ai_chat_stop = /** @type {(inputs: Admin_Ai_Chat_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detener`)
};

const fr_admin_ai_chat_stop = /** @type {(inputs: Admin_Ai_Chat_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrêter`)
};

const nl_admin_ai_chat_stop = /** @type {(inputs: Admin_Ai_Chat_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stoppen`)
};

/** @type {(inputs: Admin_Ai_Chat_StopInputs) => LocalizedString} */
const it_admin_ai_chat_stop = en_admin_ai_chat_stop;

/** @type {(inputs: Admin_Ai_Chat_StopInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_stop = en_admin_ai_chat_stop;

/** @type {(inputs: Admin_Ai_Chat_StopInputs) => LocalizedString} */
const pl_admin_ai_chat_stop = en_admin_ai_chat_stop;

/** @type {(inputs: Admin_Ai_Chat_StopInputs) => LocalizedString} */
const hu_admin_ai_chat_stop = en_admin_ai_chat_stop;

/** @type {(inputs: Admin_Ai_Chat_StopInputs) => LocalizedString} */
const ro_admin_ai_chat_stop = en_admin_ai_chat_stop;

/**
* | output |
* | --- |
* | "Stop" |
*
* @param {Admin_Ai_Chat_StopInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_stop = /** @type {((inputs?: Admin_Ai_Chat_StopInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_StopInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_stop(inputs)
	if (locale === "de") return de_admin_ai_chat_stop(inputs)
	if (locale === "es") return es_admin_ai_chat_stop(inputs)
	if (locale === "fr") return fr_admin_ai_chat_stop(inputs)
	if (locale === "nl") return nl_admin_ai_chat_stop(inputs)
	if (locale === "it") return it_admin_ai_chat_stop(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_stop(inputs)
	if (locale === "pl") return pl_admin_ai_chat_stop(inputs)
	if (locale === "hu") return hu_admin_ai_chat_stop(inputs)
	return ro_admin_ai_chat_stop(inputs)
});
export { admin_ai_chat_stop as "admin.ai_chat.stop" }